import type { ReactNode } from "react";
import { Typography, useTheme } from "@mui/material";

interface IdentityTagProps {
  children: ReactNode;
  /** A tooltip, e.g. why a listing couldn't be matched. */
  title?: string;
}

/** A neutral chip after the ticker or on the second line: the exchange, "Not covered"… */
export const IdentityTag = ({ children, title }: IdentityTagProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  return (
    <Typography
      component="span"
      noWrap
      title={title}
      sx={{
        flex: "none",
        fontSize: "0.6875rem",
        fontWeight: 600,
        color: "text.secondary",
        backgroundColor: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.05)",
        borderRadius: 0.75,
        px: 0.625,
        py: 0.125,
      }}
    >
      {children}
    </Typography>
  );
};
